import "./style.scss"
import { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from 'react-router';
import Logo from '@images/logo.png'
import LogoDark from '@images/logo-dark.png'

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/o-nas", label: "O nas" },
  { to: "/case-study", label: "Case Study" },
  { to: "/kontakt", label: "Kontakt" },
]

export default function Header () {
  const [sticky, setSticky] = useState(false)
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  // Pages without a dark hero image (detail page, 404) need the header with dark text
  const heroPages = ["/", "/o-nas", "/case-study", "/kontakt"]
  const light = !heroPages.includes(pathname.replace(/\/$/, "") || "/")
  const close = () => setOpen(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    const isSticky = () => {
        const scrollTop = window.scrollY;
        scrollTop >= 10 ? setSticky(true) : setSticky(false);
    };

    window.addEventListener('scroll', isSticky);
    return () => {
        window.removeEventListener('scroll', isSticky);
    };
  }, []);

  // Lock page scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : ""
    return () => { document.body.style.overflow = "" }
  }, [open])

  return (
    <header className={`header ${open ? "nav-open" : ""} ${sticky ? "is-sticky" : ""} ${light ? "is-light" : ""}`}>
      <div className="header-wrapper">
        <button type="button" className={open ? "burger open" : "burger"} onClick={() => { setOpen(!open) }} aria-label={open ? "Zamknij menu" : "Otwórz menu"} aria-expanded={open}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Link className="logo" to={"/"} onClick={close}>
          <img src={light ? LogoDark : Logo} alt="izipizi agency" />
        </Link>

        <div className={open ? "nav-backdrop open" : "nav-backdrop"} onClick={close}></div>
        <nav className={open ? "open" : ""}>
          <p className="nav-copy">Copyright © 2026 izipizi.agency</p>
          <ul>
            {links.map((link) => (
              <li key={link.to}><NavLink to={link.to} end={link.end} onClick={close}>{link.label}</NavLink></li>
            ))}
          </ul>
          <Link className="nav-button" to={"/kontakt"} onClick={close}>Poznajmy się</Link>
        </nav>

        {/* Speech bubble icon on mobile, outlined button on desktop */}
        <Link className="header-cta" to={"/kontakt"} onClick={close} aria-label="Porozmawiaj ze strategiem">
          <svg className="cta-icon" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round">
            <path d="M20 3C10.6 3 3 10.1 3 19c0 9 7.600 16.500 17 16.500 3 0 5.700-.7 8-2 1.500 1.200 3.700 2 6.300 1.700-1.300-1.300-2.100-2.800-2.200-4.400C35.200 28 37 23.800 37 19 37 10.100 29.400 3 20 3z" />
            <circle cx="13.500" cy="19.500" r="1.600" fill="currentColor" stroke="none" />
            <circle cx="20" cy="19.500" r="1.600" fill="currentColor" stroke="none" />
            <circle cx="26.500" cy="19.500" r="1.600" fill="currentColor" stroke="none" />
          </svg>
          <span className="cta-text">Porozmawiaj ze strategiem</span>
        </Link>
      </div>
    </header>
  )
}
